import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    registButton: {
      textAlign: 'right'
    },

    pageTitleBar: {
      backgroundColor: '#999999'
    },

    pageTitle: {
      color: '#FFFFFF',
      fontWeight: 'bold',
      padding: 15,
      fontSize: 24
    },

    backLinkWrapper: {
      minWidth: 90,
      marginLeft: 15,
      marginTop: 15,
      backgroundColor: 'white'
    },

    backLink: {
      color: 'black',
      textDecoration: 'none'
    }
  })
);
